export default __webpack_public_path__ + "2010 External field control of collective spin excitations in an optical lattice of 2-sigma molecules.pdf";